export default __webpack_public_path__ + "static/media/position-status-4.98cbae19.svg";